/* eslint-disable */

export default {
  visa: {
    title: 'Visa',
    shortTypeFromServer: 'visa',
    shortType: 'v',
    img: require(`@/assets/card-logos/visa.png`),
  },
  mastercard: {
    title: 'Mastercard',
    shortTypeFromServer: 'mastercard',
    shortType: 'm',
    img: require(`@/assets/card-logos/mastercard.png`),
  },
  'american-express': {
    title: 'American Express',
    shortTypeFromServer: 'amex',
    shortType: 'a',
    img: require(`@/assets/card-logos/american-express.png`),
  },
  'diners-club': {
    title: 'Diners Club',
    shortType: 'diners',
    img: require(`@/assets/card-logos/diners-club.png`),
  },
  discover: {
    title: 'Discover',
    shortType: 'discover',
    img: require(`@/assets/card-logos/discover.png`),
  },
  jcb: {
    title: 'JCB',
    shortType: 'jcb',
    img: require(`@/assets/card-logos/jcb.png`),
  },
  unionpay: {
    title: 'UnionPay',
    shortType: 'union',
    img: require(`@/assets/card-logos/unionpay.png`),
  },
  maestro: {
    title: 'Maestro',
    shortType: 'maestro',
    img: require(`@/assets/card-logos/maestro.png`),
  },
  mir: {
    title: 'Mir',
    shortType: 'mir',
    img: require(`@/assets/card-logos/mir.png`),
  },
  elo: {
    title: 'Elo',
    shortType: 'elo',
    img: require(`@/assets/card-logos/elo.png`),
  },
  hiper: {
    title: 'Hiper',
    shortType: 'hiper',
    img: require(`@/assets/card-logos/hiper.png`),
  },
  hipercard: {
    title: 'Hipercard',
    shortType: 'hipercard',
    img: require(`@/assets/card-logos/hipercard.png`),
  },
};
